import script from "./MouseTrail.vue?vue&type=script&setup=true&lang=js"
export * from "./MouseTrail.vue?vue&type=script&setup=true&lang=js"

import "./MouseTrail.vue?vue&type=style&index=0&id=6570ed2a&lang=css"

const __exports__ = script;

export default __exports__